import { Drawer, Skeleton, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { ThemeColor } from "../Theme/theme";
import { GetNotification } from "../ApiServices/Apifun";

const NotificationDrawer = ({ open, setopen }) => {
  const [incomingNotification, setIncomingNotification] = useState([]);
  const [loader, setLoader] = useState(false);
  const Notifications = () => {
    setLoader(true);
    GetNotification()
      .then((res) => {
        if (res.status) {
          setIncomingNotification(res.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    Notifications();
  }, []);
  return (
    <Drawer
      title={<p className="text-white">Notification</p>}
      width={500}
      headerStyle={{
        background: ThemeColor.primary,
        color: ThemeColor.bswhite,
      }}
      placement="right"
      onClose={() => setopen(false)}
      open={open}
    >
      <Spin spinning={loader}>
        {incomingNotification.length>0&& incomingNotification.map((i, index) => {
          return (
            <div key={index}>
              <div className="flex my-3 justify-between items-start gap-2">
                <Skeleton.Avatar active={true} size={40} shape={"circle"} />

                <div className="w-full">
                  <p className="font-semibold">{i?.title}</p>
                 <div className="mt-1" dangerouslySetInnerHTML={{__html:i.description}}></div>
                </div>
                {/* <p className="text-bsgray600 font-semibold">Monday</p> */}
              </div>
              <hr />
            </div>
          );
        })}
      </Spin>
    </Drawer>
  );
};

export default NotificationDrawer;
